import { render, staticRenderFns } from "./MyExcursions.vue?vue&type=template&id=67a4bfad&scoped=true"
import script from "./MyExcursions.vue?vue&type=script&lang=ts"
export * from "./MyExcursions.vue?vue&type=script&lang=ts"
import style0 from "./MyExcursions.vue?vue&type=style&index=0&id=67a4bfad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a4bfad",
  null
  
)

export default component.exports